// Tag for graphql format
const gql = String.raw;

// Fragments
import {
	CallActivityPerformanceFragment,
	CustomerSatisfactionStoreFragment,
	LongevityFragment,
	CommissionTiersFragment,
	BonusDefinitionFragment,
	MetricFragment,
	InputValueFragment,
	VolumeBonusFragment,
	VariableOperationsGpsBonusSetupFragment,
} from "@PayPlans/api/fragments/commons";

import {
	CrossStoreCommissionsFragment,
	DefaultCommissionsFragment,
	GrowthBonusFragment,
	MarketShareFragment,
	PinnacleFragment,
	RankingBonusFragment,
	SFEBonusFragment,
	MarketMakeFragment,
	OperatingCostsFragment,
} from "@PayPlans/api/fragments/managers/sales";

export const onCreateSalesDepartmentalPayPlan = gql`
	subscription onCreateSalesDepartmentalPayPlan($locationId: String, $position: String) {
		onCreateSalesDepartmentalPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			default {
				...DefaultCommissions
			}
			crossStoreCommissions {
				...CrossStoreCommissions
			}
			volumeBonus {
				...VolumeBonus
			}
			rankingBonus {
				...RankingBonus
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			marketShare {
				...MarketShare
			}
			growthBonus {
				...GrowthBonus
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			sfe {
				...SFEBonus
			}
			pinnacle {
				...Pinnacle
			}
			longevity {
				...Longevity
			}
			variableOperationsGpsBonus {
				...VariableOperationsGpsBonusSetup
			}
			locked
			available
			formatVersion
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${CrossStoreCommissionsFragment}
	${DefaultCommissionsFragment}
	${VolumeBonusFragment}
	${RankingBonusFragment}
	${CallActivityPerformanceFragment}
	${MarketShareFragment}
	${GrowthBonusFragment}
	${CustomerSatisfactionStoreFragment}
	${SFEBonusFragment}
	${PinnacleFragment}
	${LongevityFragment}
	${CommissionTiersFragment}
	${BonusDefinitionFragment}
	${MarketMakeFragment}
	${MetricFragment}
	${InputValueFragment}
	${VariableOperationsGpsBonusSetupFragment}
`;

export const onCloneSalesDepartmentalPayPlan = gql`
	subscription onCloneSalesDepartmentalPayPlan($locationId: String, $position: String) {
		onCloneSalesDepartmentalPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
		}
	}
`;

export const onUpdateSalesDepartmentalAvailablePayPlan = gql`
	subscription onUpdateSalesDepartmentalAvailablePayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateSalesDepartmentalAvailablePayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			available
			name
			position
		}
	}
`;

export const onDeleteSalesDepartmentalPayPlan = gql`
	subscription onDeleteSalesDepartmentalPayPlan($locationId: String, $position: String) {
		onDeleteSalesDepartmentalPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
		}
	}
`;

export const onUpdateSalesDepartmentalPayPlan = gql`
	subscription onUpdateSalesDepartmentalPayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateSalesDepartmentalPayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			locationId
			name
			position
			default {
				...DefaultCommissions
			}
			crossStoreCommissions {
				...CrossStoreCommissions
			}
			volumeBonus {
				...VolumeBonus
			}
			rankingBonus {
				...RankingBonus
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			marketShare {
				...MarketShare
			}
			growthBonus {
				...GrowthBonus
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			sfe {
				...SFEBonus
			}
			pinnacle {
				...Pinnacle
			}
			longevity {
				...Longevity
			}
			operatingCosts {
				...OperatingCosts
			}
			variableOperationsGpsBonus {
				...VariableOperationsGpsBonusSetup
			}
			locked
			available
			formatVersion
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${CrossStoreCommissionsFragment}
	${DefaultCommissionsFragment}
	${VolumeBonusFragment}
	${RankingBonusFragment}
	${CallActivityPerformanceFragment}
	${MarketShareFragment}
	${GrowthBonusFragment}
	${CustomerSatisfactionStoreFragment}
	${SFEBonusFragment}
	${PinnacleFragment}
	${LongevityFragment}
	${CommissionTiersFragment}
	${BonusDefinitionFragment}
	${MarketMakeFragment}
	${MetricFragment}
	${InputValueFragment}
	${OperatingCostsFragment}
	${VariableOperationsGpsBonusSetupFragment}
`;
